import React from 'react'
import { Box, CircularProgress } from '@mui/material'

const CircularLoader = () => {
  return (
    <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        zIndex: '15000',
        background: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(2px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
      {/* TODO:
      Loading... */}
        <CircularProgress />
    </Box>
  )
}

export default CircularLoader